// TemplatePicker - S48.1 / S48.2b.
// Selector de plantilla tipada. Lista las plantillas oficiales del catalogo
// (usePlantillasXL) mas la opcion 'Modo libre' (templateId = null).
// S48.2b: prop opcional `disabled` para modo factura.
//
// Props:
//   value: id de plantilla actual o null/'' para modo libre.
//   onChange: (templateId|null) => void.
//   disabled: boolean opcional.
import { useEffect, useMemo } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLSelect from '../../../components/xl/XLSelect';
import usePlantillasXL from '../hooks/usePlantillasXL';

const CSS_ID = 'xl-et-tplpicker-css';
const CSS = `
.xl-et-tplpicker { display: inline-flex; flex-direction: column; gap: 4px; min-width: 240px }
.xl-et-tplpicker__hint {
  font: 500 11px/1.4 var(--xl-font-sans);
  color: var(--xl-color-text-muted);
}
`;

export default function TemplatePicker({ value, onChange, disabled }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const { list } = usePlantillasXL();

  const options = useMemo(() => {
    const opts = [{ value: '', label: 'Modo libre (sin plantilla)' }];
    list.forEach((t) => {
      const lbl = t.demoOnly ? (t.label + ' [DEMO]') : t.label;
      opts.push({ value: t.id, label: lbl });
    });
    return opts;
  }, [list]);

  const handle = (e) => {
    const v = e.target.value;
    if (typeof onChange === 'function') {
      onChange(v ? v : null);
    }
  };

  return (
    <label className="xl-et-tplpicker">
      <span className="xl-et-tplpicker__hint">Plantilla</span>
      <XLSelect
        value={value || ''}
        onChange={handle}
        options={options}
        disabled={!!disabled}
        ariaLabel="Plantilla de etiqueta"
      />
    </label>
  );
}
